import { makeAutoObservable } from 'mobx';
import { toast } from 'react-toastify';
import {
  getBoards,
  getProjectStatuses,
  getTypesOfWork,
  setAworkAuthToken,
} from 'services/integrations/AworkHttpService';

export class AworkIntegrationStore {
  stores: any = {};
  integrationID: string = '';
  boards: any = [];
  statuses: any = [];
  typesOfWork: any = [];
  accessToken: string = '';

  constructor() {
    makeAutoObservable(this);
  }

  setStores(stores) {
    this.stores = stores;
  }

  setIntegrationID = (integrationID) => {
    this.integrationID = integrationID;
  };

  setAccessToken = (accessToken) => {
    this.accessToken = accessToken;
  };

  setAuth = async (accessToken) => {
    try {
      const response = await setAworkAuthToken(
        this.stores.projectStore.currentProject.id,
        accessToken,
      );

      if (response.status === 201) {
        this.setIntegrationID(response.data.integrationID);
        this.setAccessToken(accessToken);
      }
    } catch (err: any) {
      toast.error('Something went wrong!');
    }
  };

  setBoards = (boards) => {
    this.boards = boards;
  };

  getBoards = async () => {
    try {
      const response = await getBoards(this.accessToken);
      if (response.status === 200) {
        this.setBoards(response.data);
      }
    } catch (err: any) {
      toast.error('Something went wrong!');
    }
  };

  setStatuses = (statuses) => {
    this.statuses = statuses;
  };

  getProjectStatuses = async (boardID) => {
    if (!boardID || !this.stores?.projectStore?.currentProject?.id) {
      return;
    }

    try {
      const response = await getProjectStatuses(this.accessToken, boardID);
      if (response.status === 200) {
        this.setStatuses(response.data);
      }
    } catch (err: any) {
      toast.error('Something went wrong!');
    }
  };

  setTypesOfWork = (typesOfWork) => {
    this.typesOfWork = typesOfWork;
  };

  getTypesOfWork = async () => {
    try {
      const response = await getTypesOfWork(this.accessToken);
      if (response.status === 200) {
        this.setTypesOfWork(response.data);
      }
    } catch (err: any) {
      toast.error('Something went wrong!');
    }
  };
}
